module.exports = __webpack_public_path__ + "img/footer-shape-2.fbb8ac13.png";